import { cryptoCurrenciesMetaSelector } from 'components/features/rewards/rewardsPane/store/selectors/currencies'
import { CryptoCurrencyId, CryptoCurrencyStaticMeta } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { Collection } from 'interfaces'

export function useGetCryptoCurrencySymbolByIdOrNull (cryptoCurrencyId: CryptoCurrencyId | null): string {
  const currenciesMetaOrNull: Collection<CryptoCurrencyStaticMeta, 'id'> | null = useStoreSelector(cryptoCurrenciesMetaSelector)
  return (cryptoCurrencyId && currenciesMetaOrNull?.byKey[cryptoCurrencyId]?.abbreviation) || ''
}
